<template>
  <div class="container mx-auto text-center mt-28">
    <span class="iconfont"> &#xe606; </span>
    <h2 class="text-xl font-bold mt-5">客资链接已失效</h2>
    <span class="mt-3 block">请前往云雀客户端内查看</span>
  </div>
</template>

<script>
export default {
  name: "Expire",
};
</script>

<style scoped>
.container {
  margin: 0 auto;
  width: 100%;
  max-width: 650px;
  margin-top: 7rem;
  text-align: center;
}

.iconfont {
  font-size: 3.75rem;
  line-height: 1;
  color: #eeb142;
}

h2 {
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.75rem;
  margin-top: 1.25rem;
}
</style>

